import { render, staticRenderFns } from "./RoleUserList.vue?vue&type=template&id=131ef3f5&scoped=true"
import script from "./RoleUserList.vue?vue&type=script&lang=js"
export * from "./RoleUserList.vue?vue&type=script&lang=js"
import style0 from "./RoleUserList.vue?vue&type=style&index=0&id=131ef3f5&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131ef3f5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('131ef3f5')) {
      api.createRecord('131ef3f5', component.options)
    } else {
      api.reload('131ef3f5', component.options)
    }
    module.hot.accept("./RoleUserList.vue?vue&type=template&id=131ef3f5&scoped=true", function () {
      api.rerender('131ef3f5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/RoleUserList.vue"
export default component.exports